import React from 'react';

import TimeseriesGraphContent from './TimeseriesGraphContent';
import TimeseriesValueContent from './TimeseriesValueContent';

export type TimeseriesContentInterface = {
  TimeseriesGraphContent: typeof TimeseriesGraphContent;
  TimeseriesValueContent: typeof TimeseriesValueContent;
};

export const TimeseriesContentContext =
  React.createContext<TimeseriesContentInterface>({
    TimeseriesGraphContent,
    TimeseriesValueContent,
  });
